export class Cart {
  public id : string;
  public barcode: string;
  public cart_id: string;
  public client_id: string;
  public client_reference: string;
  public client_reference__icontains: string;
  public count: string;
  public email: string;
  public expiration_date: string;
  public name: string;
  public originalName: string;
  public status: string;
  public user_last_name: string;
  public user_id: string;
  public client__name: string;
  public creation_date: string;
}
